import React from 'react';
import classNames from 'classnames';

import css from './IconChevronLeft.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconChevronLeft = props => {
  const { className, rootClassName, proposal } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
  );
};

export default IconChevronLeft;
